import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Video, Globe } from "lucide-react";

const ServiceSwitch = () => {
  const location = useLocation();
  const isWebseiten = location.pathname.startsWith("/webseiten");

  // Use purple accent on /webseiten page, green elsewhere
  const activeColor = isWebseiten ? "accent-purple" : "electric-green";

  return (
    <motion.div 
      className="relative flex items-center bg-white/5 border border-white/10 rounded-full p-1"
      whileHover={{ scale: 1.02, borderColor: "rgba(255,255,255,0.2)" }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
    >
      {/* Animated background pill with enhanced switch animation */}
      <motion.div
        className={`absolute h-[calc(100%-8px)] rounded-full border shadow-lg ${
          isWebseiten 
            ? "bg-accent-purple/20 border-accent-purple/30 shadow-[0_0_10px_rgba(168,85,247,0.3)]" 
            : "bg-electric-green/20 border-electric-green/30 shadow-[0_0_10px_rgba(0,255,136,0.2)]"
        }`}
        initial={false}
        animate={{
          left: isWebseiten ? "calc(50% + 2px)" : "4px",
          width: isWebseiten ? "calc(50% - 6px)" : "calc(50% - 6px)",
          scaleX: [1, 1.15, 1], // Squish effect during transition
        }}
        transition={{ 
          type: "spring", 
          stiffness: 300, 
          damping: 25,
          scaleX: { duration: 0.3 }
        }}
      />
      
      {/* Film Option */}
      <Link to="/" aria-label="Zur Videoproduktion">
        <motion.div
          className={`relative z-10 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer ${
            !isWebseiten ? "text-electric-green" : "text-foreground/50"
          }`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9, rotate: -5 }}
          transition={{ type: "spring", stiffness: 400, damping: 25 }}
        >
          <motion.div
            animate={{ rotate: !isWebseiten ? [0, -10, 0] : 0 }}
            transition={{ duration: 0.3 }}
          >
            <Video className="w-3 h-3" />
          </motion.div>
          <span className="hidden sm:inline">Film</span>
        </motion.div>
      </Link>
      
      {/* Web Option */}
      <Link to="/webseiten" aria-label="Zu Webseiten">
        <motion.div
          className={`relative z-10 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer ${
            isWebseiten ? "text-accent-purple" : "text-foreground/50"
          }`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9, rotate: 5 }}
          transition={{ type: "spring", stiffness: 400, damping: 25 }}
        >
          <motion.div
            animate={{ rotate: isWebseiten ? [0, 360] : 0 }}
            transition={{ duration: 0.5 }}
          >
            <Globe className="w-3 h-3" />
          </motion.div>
          <span className="hidden sm:inline">Web</span>
        </motion.div>
      </Link>
    </motion.div>
  );
};

export default ServiceSwitch;
